import React from 'react'
import Header from '../../components/shared/Header'
import Footer from '../../components/shared/Footer'
import Glossary from '../../images/Glossary (1).png'
function CarbonIncentive() {

    const carbonData = [
    {
      title: "Carbon credit:",
      description: "A tradable certificate or permit representing the right to emit one ton of carbon dioxide or its equivalent. Carbon credits are often generated by projects that reduce or remove greenhouse gas emissions, and they can be bought and sold on the carbon market."
    },
    {
      title: "Credit issued:",
      description: "The formal recognition and issuance of carbon credits or other environmental certificates to a project that has successfully reduced or removed greenhouse gas emissions, as verified and validated by relevant authorities."
    },
    {
      title: "Carbon certification programme:",
      description: "A structured program that certifies and validates the environmental performance of projects, initiatives, or organizations in terms of their greenhouse gas emission reductions or sustainability practices."
    },
    {
      title: "Voluntary carbon credit:",
      description: "Tradable certificates representing a reduction or removal of greenhouse gas emissions that are not legally mandated. Individuals or organizations purchase voluntary carbon credits to offset their own emissions or support environmental projects."
    },
    {
      title: "Compliance carbon credit:",
      description: "Tradable certificates representing a reduction or removal of greenhouse gas emissions in compliance with legally mandated emission reduction targets or regulatory requirements."
    }
  ];

  const CarbonItem = ({ title, description }) => {
  return (
    <div className="flex flex-col items-start p-0 gap-4 w-full max-w-[1152px]">
      <h3 className="text-[24px] font-medium text-2xl leading-[29px] text-[#141414]">
        {title}
      </h3>
      <p className="w-full  font-normal text-[16px] leading-[150%] text-[#141414]">
        {description}
      </p>
    </div>
  );
};
  return (
    <>
    <Header/>
    <div className="relative w-full max-w-[1440px] h-[933px] top-[0px] mx-auto">
      {/* Text Section */}
      <div className="absolute w-full max-w-[1200px] h-[76px] left-1/2 transform -translate-x-1/2 top-[82px] flex flex-col items-center p-0 gap-10">
        <h1 className="w-full max-w-[688px] h-[76px] font-['SF_Pro_Display'] font-medium text-6xl leading-[76px] text-center text-[#141414]">
          Measurement & Tracking
        </h1>
      </div>

      {/* Image Section */}
      <img 
        className="absolute w-full top-[275px] rounded-2xl  object-cover"
        src={Glossary}
        alt="Carbon Incentive"
      />
    </div>


 <div className="w-full max-w-[1200px] mx-auto mt-20 mb-20 flex flex-col items-start gap-8">
      <h2 className=" font-bold text-[32px] leading-[38px] text-[#0D924F]">
          Measurement & Tracking
      </h2>
      <div className="flex flex-col gap-6 w-full">
        {carbonData.map((item, index) => (
          <CarbonItem 
            key={index}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </div>
    <Footer/>
    </>



  )
}

export default CarbonIncentive